export enum CompanyStatus {
    Active = 'Active',
    Blocked = 'Blocked',
    OffPlatform = 'OffPlatform',
    Removed = 'Removed',
}
